<template>
  <div class="pa-4 curva-desgaste-wrapper">
    <!-- Botón Volver -->
    <v-btn @click="$router.back()" class="back-btn mb-3">
      <v-icon left>mdi-arrow-left</v-icon>
      VOLVER
    </v-btn>

    <v-col cols="12" class="pa-0">
      <v-card class="modern-report-card elevation-2">
        <!-- Header moderno con gradiente y botón de ayuda (Estilo ReporteConsolidado) -->
        <div class="report-header-banner">
          <div class="d-flex align-center header-main-info">
            <div class="header-icon-box mr-3 flex-shrink-0">
              <v-icon color="white">mdi-chart-bell-curve-cumulative</v-icon>
            </div>
            <div class="header-text-block">
              <div class="font-weight-bold white--text header-company-title">
                Curva de Desgaste de Neumático
              </div>
              <div class="header-report-subtitle">
                Análisis de remanente proyectado y rendimiento por neumático
              </div>
            </div>
          </div>

          <div
            class="header-help-btn ml-auto flex-shrink-0 d-flex align-center"
          >
            <!-- Chip del neumático activo en el header -->
            <v-chip
              v-if="visualizarGrafico && Neumatico && Neumatico.num_serie"
              small
              class="d-none d-sm-inline-flex mr-2 tire-header-chip"
            >
              <v-icon left x-small color="amber lighten-2">mdi-tire</v-icon>
              N° Serie: <strong>{{ Neumatico.num_serie }}</strong>
            </v-chip>

            <!-- Botón de ayuda -->
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mx-1 btn-circle-tooltip"
                  icon
                  dark
                  target="_blank"
                  :href="helpdeskUrl + 'curva-desgaste-neumatico'"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon size="22" color="amber lighten-2"
                    >mdi-help-circle-outline</v-icon
                  >
                </v-btn>
              </template>
              <span>¿Necesitas ayuda?</span>
            </v-tooltip>
          </div>
        </div>

        <!-- Cuerpo del Reporte -->
        <v-card-text class="pa-4 pa-md-5">
          <v-row>
            <!-- Columna Izquierda: Tabla Selector de Neumáticos -->
            <v-col cols="12" md="4" lg="3" class="pr-md-2">
              <v-card
                class="dashboard-chart-card rounded-lg overflow-hidden elevation-1 h-100"
              >
                <div
                  class="chart-subtitle-bar px-3 py-2 d-flex align-center justify-space-between"
                >
                  <div class="d-flex align-center">
                    <v-icon small color="primary" class="mr-2">mdi-tire</v-icon>
                    <span
                      class="font-weight-bold text-caption text-uppercase text--primary"
                    >
                      Neumáticos
                    </span>
                  </div>
                  <v-chip
                    v-if="total > 0"
                    x-small
                    color="primary lighten-4"
                    class="primary--text font-weight-bold"
                  >
                    {{ total }} unid.
                  </v-chip>
                </div>
                <div class="pa-2 tire-selector-table-wrap">
                  <TablaNeumaticos
                    @enviarDatos="enviarDatos"
                    :Cabecera="Cabecera"
                    :loading="Loader"
                    :Items="Neumaticos"
                    :data="data"
                    :total="total"
                    :per_page="per_page"
                    :from="from"
                    :to="to"
                    :page="page"
                    @getNeumaticos="getNeumaticos"
                  >
                  </TablaNeumaticos>
                </div>
              </v-card>
            </v-col>

            <!-- Columna Derecha: Gráfico, Ficha Técnica y KPIs -->
            <v-col cols="12" md="8" lg="9" class="pl-md-2">
              <!-- Estado 1: Cargando datos del gráfico -->
              <div
                v-if="cargandoGrafico"
                class="chart-loading-state rounded-lg pa-10 d-flex flex-column align-center justify-center text-center"
              >
                <v-progress-circular
                  indeterminate
                  size="52"
                  width="4"
                  color="primary"
                  class="mb-4"
                ></v-progress-circular>
                <div
                  class="text-subtitle-1 font-weight-bold grey--text text--darken-3 mb-1"
                >
                  Cargando análisis del neumático...
                </div>
                <div class="text-caption grey--text text--darken-1">
                  Generando curva de desgaste y proyecciones
                </div>
              </div>

              <!-- Estado 2: Sin neumático seleccionado -->
              <div
                v-else-if="!visualizarGrafico"
                class="chart-empty-state rounded-lg pa-8 pa-md-12 d-flex flex-column align-center justify-center text-center"
              >
                <div class="empty-state-icon-circle mb-4">
                  <v-icon size="48" color="primary lighten-1"
                    >mdi-chart-timeline-variant</v-icon
                  >
                </div>
                <h3
                  class="text-h6 font-weight-bold grey--text text--darken-3 mb-2"
                >
                  Seleccione un neumático
                </h3>
                <p
                  class="text-body-2 grey--text text--darken-1 max-width-480 mb-4"
                >
                  Haga clic en cualquiera de los neumáticos del listado a la
                  izquierda para visualizar su curva de desgaste proyectada,
                  histórico de remanentes y métricas de rendimiento.
                </p>
                <v-chip
                  outlined
                  small
                  color="primary"
                  class="font-weight-medium"
                >
                  <v-icon left x-small>mdi-cursor-default-click</v-icon>
                  Seleccione un neumático para comenzar
                </v-chip>
              </div>

              <!-- Estado 3: Neumático seleccionado y datos listos -->
              <div v-else class="graph-content-section">
                <!-- 1. Ficha Técnica del Neumático Seleccionado -->
                <v-card
                  class="dashboard-chart-card rounded-lg pa-0 overflow-hidden elevation-1 mb-4"
                >
                  <div
                    class="chart-subtitle-bar px-4 py-2 d-flex align-center justify-space-between flex-wrap"
                  >
                    <div class="d-flex align-center">
                      <v-icon small color="primary" class="mr-2"
                        >mdi-information-outline</v-icon
                      >
                      <span
                        class="font-weight-bold text-caption text-uppercase text--primary"
                      >
                        Ficha Técnica del Neumático
                      </span>
                    </div>
                    <div class="d-flex align-center">
                      <v-chip
                        small
                        :color="
                          getEstadoChipColor(Neumatico.descripcion_estado)
                        "
                        text-color="white"
                        class="font-weight-bold text-caption text-uppercase"
                      >
                        <v-icon left x-small>mdi-shield-check</v-icon>
                        {{ Neumatico.descripcion_estado || "Sin estado" }}
                      </v-chip>
                    </div>
                  </div>

                  <div class="pa-4 bg-spec-grid">
                    <v-row dense>
                      <!-- Serie -->
                      <v-col cols="6" sm="4" md="2">
                        <div class="tire-spec-box">
                          <div class="spec-label">
                            <v-icon x-small color="grey darken-1" class="mr-1"
                              >mdi-barcode</v-icon
                            >
                            N° SERIE
                          </div>
                          <div
                            class="spec-value primary--text font-weight-bold text-truncate"
                            :title="Neumatico.num_serie"
                          >
                            {{ Neumatico.num_serie || "-" }}
                          </div>
                        </div>
                      </v-col>

                      <!-- Marca -->
                      <v-col cols="6" sm="4" md="2">
                        <div class="tire-spec-box">
                          <div class="spec-label">
                            <v-icon x-small color="grey darken-1" class="mr-1"
                              >mdi-tag-outline</v-icon
                            >
                            MARCA
                          </div>
                          <div
                            class="spec-value text-truncate"
                            :title="Neumatico.marca"
                          >
                            {{ Neumatico.marca || "-" }}
                          </div>
                        </div>
                      </v-col>

                      <!-- Modelo -->
                      <v-col cols="6" sm="4" md="2">
                        <div class="tire-spec-box">
                          <div class="spec-label">
                            <v-icon x-small color="grey darken-1" class="mr-1"
                              >mdi-cube-outline</v-icon
                            >
                            MODELO
                          </div>
                          <div
                            class="spec-value text-truncate"
                            :title="Neumatico.modelo"
                          >
                            {{ Neumatico.modelo || "-" }}
                          </div>
                        </div>
                      </v-col>

                      <!-- Medida -->
                      <v-col cols="6" sm="4" md="2">
                        <div class="tire-spec-box">
                          <div class="spec-label">
                            <v-icon x-small color="grey darken-1" class="mr-1"
                              >mdi-ruler</v-icon
                            >
                            MEDIDA
                          </div>
                          <div
                            class="spec-value text-truncate"
                            :title="Neumatico.medida"
                          >
                            {{ Neumatico.medida || "-" }}
                          </div>
                        </div>
                      </v-col>

                      <!-- Diseño -->
                      <v-col cols="6" sm="4" md="2">
                        <div class="tire-spec-box">
                          <div class="spec-label">
                            <v-icon x-small color="grey darken-1" class="mr-1"
                              >mdi-texture-box</v-icon
                            >
                            DISEÑO
                          </div>
                          <div
                            class="spec-value text-truncate"
                            :title="Neumatico.disenio"
                          >
                            {{ Neumatico.disenio || "-" }}
                          </div>
                        </div>
                      </v-col>

                      <!-- Estado -->
                      <v-col cols="6" sm="4" md="2">
                        <div class="tire-spec-box">
                          <div class="spec-label">
                            <v-icon x-small color="grey darken-1" class="mr-1"
                              >mdi-list-status</v-icon
                            >
                            CONDICIÓN
                          </div>
                          <div
                            class="spec-value text-truncate"
                            :title="Neumatico.descripcion_estado"
                          >
                            {{ Neumatico.descripcion_estado || "-" }}
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </v-card>

                <!-- 2. Gráfico de la Curva de Desgaste con Controles -->
                <v-card
                  class="dashboard-chart-card rounded-lg pa-0 overflow-hidden elevation-1 mb-4"
                >
                  <div
                    class="chart-subtitle-bar px-4 py-2 d-flex align-center justify-space-between flex-wrap"
                  >
                    <div class="d-flex align-center py-1">
                      <v-icon small color="primary" class="mr-2"
                        >mdi-chart-line</v-icon
                      >
                      <span
                        class="font-weight-bold text-caption text-uppercase text--primary"
                      >
                        Curva de Desgaste (Remanente vs {{ labelScaleX }})
                      </span>
                      <v-chip
                        x-small
                        color="grey lighten-3"
                        class="ml-2 font-weight-medium grey--text text--darken-2 d-none d-sm-inline-flex"
                      >
                        Eje: {{ labelScaleX }}
                      </v-chip>
                    </div>

                    <!-- Switch de Inspecciones Anteriores con mejor UX -->
                    <div class="d-flex align-center py-1">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <div
                            v-bind="attrs"
                            v-on="on"
                            class="switch-container"
                          >
                            <v-switch
                              v-model="switch_inspecciones"
                              hide-details
                              dense
                              class="mt-0 pt-0 modern-switch"
                              color="primary"
                              @change="enviarDatos({ id: id_neumatico })"
                            >
                              <template v-slot:label>
                                <span
                                  class="text-caption font-weight-medium text--secondary"
                                >
                                  Mostrar Inspecciones Anteriores
                                </span>
                              </template>
                            </v-switch>
                          </div>
                        </template>
                        <span
                          >Incluir historial de inspecciones de montajes
                          previos</span
                        >
                      </v-tooltip>
                    </div>
                  </div>

                  <!-- Indicador de desplazamiento horizontal en móvil -->
                  <div
                    class="chart-mobile-swipe-hint d-flex d-sm-none align-center justify-space-between px-3 py-1"
                  >
                    <span
                      class="text-caption d-flex align-center font-weight-medium primary--text"
                      style="font-size: 0.72rem !important"
                    >
                      <v-icon x-small color="primary" class="mr-1"
                        >mdi-gesture-swipe-horizontal</v-icon
                      >
                      Desliza para explorar la curva
                    </span>
                    <span
                      class="text-caption grey--text text--darken-1 font-weight-medium"
                      style="font-size: 0.72rem !important"
                    >
                      Eje: {{ labelScaleX }}
                    </span>
                  </div>

                  <!-- Contenedor del Gráfico -->
                  <div class="pa-2 pa-sm-4 chart-canvas-container">
                    <GraficoLine
                      :DatosGrafico="DatosGrafico"
                      title="Curva de desgaste"
                      :Labels="Labels"
                      :Labelscale_x="labelScaleX"
                      Labelscale_y="Remanente (mm)"
                    ></GraficoLine>
                  </div>
                </v-card>

                <!-- Compatibilidad de cálculo -->
                <div hidden>
                  {{ calcularPorcentaje(Neumatico.porcentaje) }}
                </div>

                <!-- 3. Tarjetas KPI de Rendimiento y Desgaste -->
                <div class="kpi-cards-section mb-2">
                  <v-row dense>
                    <!-- KPI 1: Remanente de Retiro -->
                    <v-col cols="12" sm="6" md="4">
                      <div class="kpi-metric-card">
                        <div class="kpi-icon-wrap amber lighten-5">
                          <v-icon color="amber darken-3"
                            >mdi-ruler-square</v-icon
                          >
                        </div>
                        <div class="kpi-content">
                          <div class="kpi-label">Remanente de Retiro</div>
                          <div class="kpi-value amber--text text--darken-4">
                            {{ parseNumber(Neumatico.remanente_limite) }}
                            <span class="kpi-unit">mm</span>
                          </div>
                          <div class="kpi-subtext">
                            Límite mínimo de seguridad
                          </div>
                        </div>
                      </div>
                    </v-col>

                    <!-- KPI 2: Recorrido / Horas Proyectadas -->
                    <v-col cols="12" sm="6" md="4">
                      <div class="kpi-metric-card">
                        <div class="kpi-icon-wrap indigo lighten-5">
                          <v-icon color="indigo darken-2"
                            >mdi-chart-timeline-variant</v-icon
                          >
                        </div>
                        <div class="kpi-content">
                          <div class="kpi-label">
                            {{ labelRecorridoProyectado }}
                          </div>
                          <div class="kpi-value indigo--text text--darken-3">
                            {{ parseNumber(Neumatico.km_proyectado) }}
                            <span class="kpi-unit">{{
                              tipoCosto == 2 ? "Hrs" : "KM"
                            }}</span>
                          </div>
                          <div class="kpi-subtext">
                            Proyección hasta el retiro
                          </div>
                        </div>
                      </div>
                    </v-col>

                    <!-- KPI 3: Rendimiento -->
                    <v-col cols="12" sm="6" md="4">
                      <div class="kpi-metric-card">
                        <div class="kpi-icon-wrap teal lighten-5">
                          <v-icon color="teal darken-2">mdi-speedometer</v-icon>
                        </div>
                        <div class="kpi-content">
                          <div class="kpi-label">Rendimiento</div>
                          <div class="kpi-value teal--text text--darken-3">
                            {{ parseNumber(Neumatico.rendimiento) }}
                            <span class="kpi-unit">{{
                              tipoCosto == 2 ? "Hrs" : "KM"
                            }}</span>
                          </div>
                          <div class="kpi-subtext">Rendimiento acumulado</div>
                        </div>
                      </div>
                    </v-col>

                    <!-- KPI 4: Porcentaje de Desgaste -->
                    <v-col cols="12" sm="6" md="4">
                      <div class="kpi-metric-card">
                        <div
                          class="kpi-icon-wrap"
                          :class="getPorcentajeBgClass(Porcentaje)"
                        >
                          <v-icon :color="getPorcentajeIconColor(Porcentaje)"
                            >mdi-percent-outline</v-icon
                          >
                        </div>
                        <div class="kpi-content">
                          <div class="kpi-label">Porcentaje de Desgaste</div>
                          <div
                            class="kpi-value"
                            :class="getPorcentajeTextColor(Porcentaje)"
                          >
                            {{ Porcentaje }}
                          </div>
                          <v-progress-linear
                            :value="numericPorcentaje"
                            :color="getPorcentajeColor(Porcentaje)"
                            height="5"
                            rounded
                            class="mt-1"
                          ></v-progress-linear>
                        </div>
                      </div>
                    </v-col>

                    <!-- KPI 5: Desgaste por mm -->
                    <v-col cols="12" sm="6" md="4">
                      <div class="kpi-metric-card">
                        <div class="kpi-icon-wrap blue-grey lighten-5">
                          <v-icon color="blue-grey darken-2">mdi-scale</v-icon>
                        </div>
                        <div class="kpi-content">
                          <div class="kpi-label">{{ labelDesgasteMm }}</div>
                          <div class="kpi-value blue-grey--text text--darken-3">
                            {{ parseNumber(Neumatico.desgaste_km_mm) }}
                          </div>
                          <div class="kpi-subtext">Tasa de desgaste por mm</div>
                        </div>
                      </div>
                    </v-col>

                    <!-- KPI 6: Motivo Scrap (solo si tiene motivo) -->
                    <v-col cols="12" sm="6" md="4" v-if="Neumatico.motivo">
                      <div class="kpi-metric-card kpi-scrap-alert">
                        <div class="kpi-icon-wrap red lighten-5">
                          <v-icon color="red darken-2"
                            >mdi-alert-octagon-outline</v-icon
                          >
                        </div>
                        <div class="kpi-content">
                          <div
                            class="kpi-label red--text text--darken-3"
                            id="title_mot_scrap"
                          >
                            Motivo de Scrap
                          </div>
                          <div
                            class="kpi-value red--text text--darken-4 text-truncate"
                            :title="Neumatico.motivo"
                          >
                            {{ Neumatico.motivo }}
                          </div>
                          <div class="kpi-subtext red--text text--darken-2">
                            Causa de desecho
                          </div>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </div>

                <!-- Alerta destacada de estado del neumático -->
                <v-alert
                  v-if="Neumatico.mensaje_estado_neumatico"
                  outlined
                  type="warning"
                  prominent
                  border="left"
                  class="modern-warning-alert rounded-lg mt-3 mb-0"
                >
                  <div class="font-weight-bold text-subtitle-2 mb-1">
                    Observación del Estado del Neumático
                  </div>
                  <div class="text-body-2">
                    {{ Neumatico.mensaje_estado_neumatico }}
                  </div>
                </v-alert>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </div>
</template>

<script>
import TablaNeumaticos from "../../components/NeumaticoVerticalTable.vue";
import GraficoLine from "../../components/GraficoLine.vue";
import { mapState, mapActions } from "vuex";
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
Chart.register(ChartDataLabels);
import axios from "axios";
import Swal from "sweetalert2";
import global from "@/global";

export default {
  components: {
    TablaNeumaticos,
    GraficoLine,
  },
  data() {
    return {
      Cabecera: [
        {
          text: "",
          value: "num_serie",
          align: "center",
          sortable: false,
        },
      ],
      Neumaticos: [],
      Porcentaje: "0 %",
      Labels: [],
      DatosGrafico: [],
      visualizarGrafico: false,
      cargandoGrafico: false,
      id_neumatico: 0,
      switch_inspecciones: false,
      loading: true,
      total: 0,
      data: [],
      per_page: 5,
      page: 1,
      from: 1,
      to: 5,
      sortBy: "id",
      sortDirection: "desc",
    };
  },
  computed: {
    ...mapState("reportes", [
      "KilometrosRecorridos",
      "RemanentesOriginales",
      "RemanentesProyectados",
      "RemanentesLimite",
      "Neumatico",
    ]),
    ...mapState("neumatico", ["Items", "Loader", "ItemTotal"]),
    ...mapState("cliente", ["Cliente"]),
    helpdeskUrl() {
      return (global && global.helpdesk_url) ? global.helpdesk_url : '#';
    },
    tipoCosto() {
      if (!this.Neumatico) return 1;
      return (
        this.Neumatico.tipocosto ||
        this.Neumatico.tipo_costo ||
        this.Neumatico.vehiculo_tipo_costo ||
        1
      );
    },
    labelScaleX() {
      return this.tipoCosto == 2 ? "Horas" : "Kilómetros";
    },
    labelRecorridoProyectado() {
      return this.tipoCosto == 2 ? "Horas proyectadas" : "Recorrido proyectado";
    },
    labelDesgasteMm() {
      return this.tipoCosto == 2 ? "Desgaste (Hrs x mm)" : "Desgaste (KM x mm)";
    },
    numericPorcentaje() {
      if (!this.Porcentaje) return 0;
      const parsed = parseFloat(
        String(this.Porcentaje).replace("%", "").trim(),
      );
      return isNaN(parsed) ? 0 : Math.min(Math.max(parsed, 0), 100);
    },
  },
  watch: {
    "Neumatico.porcentaje": {
      immediate: true,
      handler(val) {
        if (val !== undefined && val !== null) {
          this.calcularPorcentaje(val);
        }
      },
    },
  },
  methods: {
    ...mapActions("reportes", [
      "DatosGraficoCurvaRemanenteNeumatico",
      "VaciarObjetoNeumatico",
    ]),
    ...mapActions("neumatico", ["cargarNeumaticos"]),
    ...mapActions("cliente", ["ObtenerDatosCliente"]),

    messageErrorAlert: function () {
      Swal.fire({
        title: "Upps, algo paso!",
        text: "Servidor desconectado, por favor actualice la ventana!",
        icon: "error",
        showCancelButton: false,
        confirmButtonColor: "#d33",
        confirmButtonText: "Actualizar",
        showClass: {
          popup: `
            animate__animated
            animate__fadeInUp
            animate__faster
          `,
        },
        hideClass: {
          popup: `
            animate__animated
            animate__fadeOutDown
            animate__faster
          `,
        },
        backdrop: `
          rgba(255,0,0,0.1)
          left top
          no-repeat
        `,
      }).then((result) => {
        if (result.isConfirmed) {
          location.reload();
        }
      });
    },

    getNeumaticos({
      page = 1,
      per_page = 5,
      search = "",
      sortBy = "id",
      sortDirection = "desc",
    }) {
      this.cargarNeumaticos({
        page,
        per_page,
        num_serie: search,
        sortBy,
        sortDirection,
      }).then(() => {
        this.Neumaticos = this.Items;
        this.data = this.Items.data;
        this.total = this.Items.total;
        this.per_page = this.Items.per_page;
        this.page = this.Items.current_page;
        this.from = this.Items.from;
        this.to = this.Items.to;
        this.loading = this.Loader;
      });
    },

    enviarDatos: async function (item) {
      if (!item || !item.id) return;
      this.id_neumatico = item.id;
      this.cargandoGrafico = true;
      try {
        await this.DatosGraficoCurvaRemanenteNeumatico({
          id: item.id,
          inspecciones_antiguas: this.switch_inspecciones,
        });
        if (this.Neumatico && this.Neumatico.porcentaje !== undefined) {
          this.calcularPorcentaje(this.Neumatico.porcentaje);
        }
        await this.generarGrafico();
      } catch (error) {
        console.error("Error al cargar datos del neumático:", error);
      } finally {
        this.cargandoGrafico = false;
      }
    },

    calcularPorcentaje: function (porcentaje) {
      if (!this.Neumatico || this.Neumatico.porcentaje === undefined) return;

      if (this.Neumatico.porcentaje === 0 && parseFloat(this.Neumatico.desgaste_km_mm) === 0) {
        this.Porcentaje = "0.00%";
      } else {
        this.Porcentaje =
        parseFloat(
          Math.round(
            (parseFloat(100.0) - parseFloat(this.Neumatico.porcentaje)) * 100,
          ) / 100,
        ).toFixed(2) + "%";
      }
     
    },

    generarGrafico: async function () {
      this.Labels = this.KilometrosRecorridos;
      this.DatosGrafico = [
        {
          label: "Remanente (mm)",
          data: this.RemanentesOriginales,
          borderColor: "rgba(0, 188, 212, 1)",
          backgroundColor: "rgba(0, 188, 212, 0.1)",
          pointBorderColor: "rgba(51, 122, 183, 1)",
          pointBackgroundColor: "rgba(51, 122, 183, 1)",
          pointBorderWidth: 1,
          cubicInterpolationMode: "monotone",
          fill: true,
        },
        {
          label: "Remanente Proyectado (mm)",
          data: this.RemanentesProyectados,
          borderColor: "rgba(234, 164, 14, 1)",
          backgroundColor: "rgba(234, 164, 14, 0.5)",
          pointBorderColor: "rgba(234, 164, 14, 0)",
          pointBackgroundColor: "rgba(234, 164, 14, 0)",
          fill: false,
          borderDash: [5, 5],
          cubicInterpolationMode: "monotone",
        },
        {
          label: "Remanente Límite (mm)",
          data: this.RemanentesLimite,
          borderColor: "rgba(225, 11, 50, 1)",
          backgroundColor: "rgba(225, 11, 50, 0)",
          pointBorderColor: "rgba(225, 11, 50, 0)",
          pointBackgroundColor: "rgba(225, 11, 50, 0)",
          cubicInterpolationMode: "monotone",
        },
      ];
      this.visualizarGrafico = false;
      await this.$nextTick();
      this.visualizarGrafico = true;
    },

    parseNumber(numberString) {
      let number = parseFloat(numberString);
      if (isNaN(number)) {
        return "-";
      }
      return number.toLocaleString("en-US", {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      });
    },

    getEstadoChipColor(estado) {
      if (!estado) return "blue-grey darken-1";
      const est = String(estado).toLowerCase();
      if (
        est.includes("instalado") ||
        est.includes("listo") ||
        est.includes("buen") ||
        est.includes("operativ")
      ) {
        return "teal darken-1";
      }
      if (
        est.includes("repar") ||
        est.includes("reencauch") ||
        est.includes("inspecc")
      ) {
        return "orange darken-2";
      }
      if (
        est.includes("scrap") ||
        est.includes("baja") ||
        est.includes("desecho")
      ) {
        return "red darken-2";
      }
      return "indigo darken-1";
    },

    getPorcentajeColor(porcentajeStr) {
      const val = parseFloat(String(porcentajeStr).replace("%", ""));
      if (isNaN(val)) return "primary";
      if (val >= 80) return "red darken-1";
      if (val >= 50) return "amber darken-2";
      return "teal darken-1";
    },

    getPorcentajeBgClass(porcentajeStr) {
      const val = parseFloat(String(porcentajeStr).replace("%", ""));
      if (isNaN(val)) return "primary lighten-5";
      if (val >= 80) return "red lighten-5";
      if (val >= 50) return "amber lighten-5";
      return "teal lighten-5";
    },

    getPorcentajeIconColor(porcentajeStr) {
      const val = parseFloat(String(porcentajeStr).replace("%", ""));
      if (isNaN(val)) return "primary";
      if (val >= 80) return "red darken-2";
      if (val >= 50) return "amber darken-3";
      return "teal darken-2";
    },

    getPorcentajeTextColor(porcentajeStr) {
      const val = parseFloat(String(porcentajeStr).replace("%", ""));
      if (isNaN(val)) return "primary--text";
      if (val >= 80) return "red--text text--darken-2";
      if (val >= 50) return "amber--text text--darken-3";
      return "teal--text text--darken-2";
    },
  },

  async mounted() {
    if (!this.Cliente || !this.Cliente.razon_social) {
      try {
        await this.ObtenerDatosCliente();
      } catch (e) {
        console.log("No se pudo obtener datos del cliente:", e);
      }
    }
  },
};
</script>

<style scoped>
/* =========================================================
   UI/UX STYLES - REPORTE CURVA DE DESGASTE DE NEUMÁTICO
   Basado en el diseño moderno de ReporteConsolidado.vue
   ========================================================= */

.curva-desgaste-wrapper {
  background-color: #f8fafc;
  min-height: 100%;
}

/* Botón Volver */
.back-btn {
  font-weight: 700;
  letter-spacing: 0.3px;
  border-radius: 8px;
  text-transform: none;
  transition: all 0.2s ease;
}

.back-btn:hover {
  transform: translateX(-2px);
}

/* Card y Header Modernos (Referencia: ReporteConsolidado) */
.modern-report-card {
  border-radius: 12px !important;
  border: 1px solid #e2e8f0 !important;
  overflow: hidden;
  background: #ffffff !important;
}

.report-header-banner {
  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
  padding: 14px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
}

.header-main-info {
  flex: 1 1 0;
  min-width: 0;
  overflow: hidden;
}

.header-text-block {
  min-width: 0;
  overflow: hidden;
}

.header-help-btn {
  flex: 0 0 auto;
  flex-shrink: 0;
  white-space: nowrap;
}

.header-icon-box {
  width: 42px;
  height: 42px;
  min-width: 42px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

.header-company-title {
  font-size: 1.05rem;
  line-height: 1.25;
  letter-spacing: 0.3px;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header-report-subtitle {
  color: #94a3b8;
  font-size: 0.78rem;
  font-weight: 500;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tire-header-chip {
  background: rgba(255, 255, 255, 0.15) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  color: #ffffff !important;
  font-weight: 600;
  letter-spacing: 0.3px;
}

.btn-circle-tooltip {
  background: rgba(255, 255, 255, 0.16) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  border-radius: 50% !important;
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  max-width: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-decoration: none !important;
  transition: all 0.2s ease-in-out !important;
}

.btn-circle-tooltip:hover {
  background: rgba(255, 255, 255, 0.28) !important;
  border-color: rgba(255, 255, 255, 0.45) !important;
  transform: scale(1.06);
}

/* Cards internas tipo Dashboard (Referencia: ReporteConsolidado) */
.dashboard-chart-card {
  border: 1px solid #e2e8f0 !important;
  background-color: #ffffff;
  transition: transform 0.2s ease, box-shadow 0.25s ease, border-color 0.2s ease;
}

.dashboard-chart-card:hover {
  border-color: #cbd5e1 !important;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.05) !important;
}

.chart-subtitle-bar {
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  border-bottom: 1px solid #e2e8f0;
  font-size: 0.815rem;
  line-height: 1.35;
  min-height: 40px;
}

.chart-canvas-container {
  background-color: #ffffff;
  min-height: 340px;
  position: relative;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.chart-mobile-swipe-hint {
  background: #f0f9ff;
  border-bottom: 1px solid #e0f2fe;
}

.chart-canvas-container::-webkit-scrollbar {
  height: 6px;
}
.chart-canvas-container::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 4px;
}
.chart-canvas-container::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}
.chart-canvas-container::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.tire-selector-table-wrap ::v-deep table {
  width: 100% !important;
}

.tire-selector-table-wrap ::v-deep thead tr:not(.v-data-table__progress) th,
.tire-selector-table-wrap ::v-deep tbody td {
  text-align: center !important;
}

.tire-selector-table-wrap ::v-deep tr.v-data-table__progress th {
  padding: 0 !important;
  height: auto !important;
  border: none !important;
  background: transparent !important;
}

.tire-selector-table-wrap ::v-deep .v-progress-linear {
  background: transparent !important;
}

.tire-selector-table-wrap ::v-deep .v-progress-linear__background {
  background-color: transparent !important;
  opacity: 0 !important;
}

.tire-selector-table-wrap ::v-deep .v-data-table__mobile-row {
  justify-content: center !important;
}

.tire-selector-table-wrap ::v-deep .v-data-table__mobile-row__cell {
  text-align: center !important;
  width: 100% !important;
  display: flex !important;
  justify-content: center !important;
}

/* Estados Vacío y Carga */
.chart-empty-state {
  min-height: 380px;
  background: #f8fafc;
  border: 1.5px dashed #cbd5e1;
}

.empty-state-icon-circle {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  display: flex;
  align-items: center;
  justify-content: center;
}

.chart-loading-state {
  min-height: 380px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
}

.max-width-480 {
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;
}

/* Ficha Técnica Grid */
.bg-spec-grid {
  background: #fafafa;
}

.tire-spec-box {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 8px 12px;
  transition: all 0.2s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.tire-spec-box:hover {
  border-color: #cbd5e1;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
}

.spec-label {
  font-size: 10.5px;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  display: flex;
  align-items: center;
  margin-bottom: 3px;
}

.spec-value {
  font-size: 13.5px;
  color: #1e293b;
  line-height: 1.25;
}

/* Switch Moderno */
.modern-switch ::v-deep .v-input--selection-controls__input {
  margin-right: 8px !important;
}

/* KPI Metric Cards (Diseño Dashboard) */
.kpi-metric-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  gap: 14px;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  height: 100%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
}

.kpi-metric-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  transform: translateY(-2px);
}

.kpi-icon-wrap {
  width: 46px;
  height: 46px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.kpi-content {
  flex-grow: 1;
  min-width: 0;
}

.kpi-label {
  font-size: 11.5px;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  line-height: 1.2;
}

.kpi-value {
  font-size: 1.25rem;
  font-weight: 800;
  line-height: 1.2;
  margin-top: 3px;
  letter-spacing: -0.02em;
}

.kpi-unit {
  font-size: 0.8rem;
  font-weight: 600;
  color: #64748b;
  margin-left: 2px;
}

.kpi-subtext {
  font-size: 11px;
  color: #94a3b8;
  margin-top: 2px;
  line-height: 1.2;
}

.kpi-scrap-alert {
  background: #fff5f5 !important;
  border-color: #fecaca !important;
}

.modern-warning-alert {
  background: #fffbeb !important;
  border-color: #f59e0b !important;
}

/* ============================================================
   RESPONSIVE: Mobile (max 600px)
   ============================================================ */
@media (max-width: 600px) {
  .report-header-banner {
    padding: 12px 14px;
    gap: 8px;
  }

  .header-icon-box {
    width: 36px;
    height: 36px;
    min-width: 36px;
  }

  .header-company-title {
    font-size: 0.85rem !important;
  }

  .header-report-subtitle {
    font-size: 0.68rem !important;
  }
}
</style>
